// istanbul ignore file # Interstate breakage.
import { rem } from 'polished';
import styled, { css } from 'styled-components';

export const VehicleProtectionContent = styled.div<{ $showPagination?: boolean }>`
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
    gap: ${rem(17)};

    #ids-table-vehicle-protection-plan-table {
        ${({ $showPagination }) =>
            $showPagination &&
            css`
                gap: ${rem(10)};
            `}
    }

    #ids-table-vehicle-protection-plan-table > div.MuiBox-root {
        display: none;

        ${({ $showPagination }) =>
            $showPagination &&
            css`
                display: block;
                padding-bottom: ${rem(10)};
            `}
    }
`;

export const LoaderWrapper = styled.div`
    display: flex;
    min-height: 36px;
    position: relative;
    justify-content: center;

    & #interstitial-overlay-root {
        background-color: transparent;
        min-width: 32px;
        min-height: 36px;
    }
    & #interstitial-content-root {
        min-width: 32px;
        box-shadow: none;
    }
`;

export const TableWrapper = styled.div`
    border: 1px solid #b2b2b2;
    margin-bottom: 0;

    & .ant-table-tbody > tr.ant-table-row > td {
        padding: ${rem(10)} ${rem(4)};
    }

    & .ant-table .ant-table-container .ant-table-content table thead.ant-table-thead > tr > th.ant-table-cell {
        padding: ${rem(10)} ${rem(4)};
    }
`;

export const VehicleOverrideEditingContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: ${rem(10)};
`;

export const VehicleEditButtonContainer = styled.div`
    display: flex;
    gap: ${rem(18)};
`;
